import React, { useState } from "react";
import MuiHeader from "../../components/MuiHeader";
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TextField,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { getManagersThunk } from "./NsdcThunk";
import api from "../../api/api";
// MUI
import {
  Avatar,
  Button,
  Box,
  Grid,
  Card,
  CardHeader,
  IconButton,
  Menu,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import AodIcon from "@mui/icons-material/Aod";
import { red, blue, green, purple } from "@mui/material/colors";

const Nsdc = () => {
  const dispatch = useDispatch();
  const theme = useTheme();
  const res = useSelector((state) => state.NsdcSlice.managers);
  // console.log("res--->", res);

  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const ITEM_HEIGHT = 48;
  const [selectedIndex, setSelectedIndex] = useState(-1);
  const [selectedSegment, setSelectedSegment] = useState({});
  const [anchorEl, setAnchorEl] = useState(null);
  const openVertMenu = Boolean(anchorEl);
  const handleVertMenuClose = () => {
    setAnchorEl(null);
    setSelectedIndex(-1);
    setSelectedSegment({});
  };
  useEffect(() => {
    dispatch(getManagersThunk());
  }, [dispatch]);

  const [managerId, setmanagerId] = useState([]);
  const [passcodeName, setPasscodeName] = useState("");
  const [user_data, set_user_data] = useState([]);
  console.log("user_data--->", user_data);
  const [userid, setUserid] = useState("");
  const [nsdcData, setNsdcData] = useState([]);
  console.log("nsdcData---->", nsdcData);
  const [nsdcMark, setNsdcMark] = useState([]);

  const handleManagerChange = (event) => {
    setmanagerId(event.target.value);
  };

  let passcodeArr = [];

  res.forEach((element) => {
    if (element.userid === managerId) {
      passcodeArr = element.passcodesarr;
    }
  });
  //console.log("passcodeArr--->", passcodeArr);

  const handlePasscodeChange = (event) => {
    setPasscodeName(event.target.value);
    api
      .get(`getnsdcusers/${managerId}/${event.target.value}`)
      .then((response) => {
        console.log("user response--->", response.data);
        set_user_data(response.data);
      });
  };

  const handleUserChange = (event) => {
    setUserid(event.target.value);
    api.get(`getansfromuser/${event.target.value}`).then((response) => {
      console.log("ans data--->", response.data);
      setNsdcData(response.data[0].questionanswer);
      setNsdcMark(response.data);
    });
  };

  const handleNsdcUpdate = () => {
    const body = {
      qid: nsdcData.qid,
      question: nsdcData.question,
      A: nsdcData.A,
      B: nsdcData.B,
      C: nsdcData.C,
      D: nsdcData.D,
      answer: nsdcData.answer,
      language: nsdcData.language,
      type: this.selected_assesment,
      category: this.selected_category,
    };
  };

  const handleNsdcDelete = () => {};

  return (
    <div>
      <MuiHeader
        header="Nsdc"
        manage_nsdc="Manage Nsdc"
        nsdc_certificate="Nsdc Certificate"
      />

      <div style={styles.select}>
        {/* For Year Select */}
        <FormControl sx={{ m: 1, minWidth: 160 }} size="small">
          <InputLabel id="demo-select-small">Select Manager</InputLabel>
          <Select
            labelId="demo-select-small"
            id="demo-select-small"
            value={managerId}
            label="Select Manager"
            onChange={handleManagerChange}>
            <MenuItem value="">
              <em>None</em>
            </MenuItem>
            {res.map((element) => (
              <MenuItem value={element.userid}>{element.username}</MenuItem>
            ))}
          </Select>
        </FormControl>

        {/* For Manager Select */}
        <FormControl sx={{ m: 1, minWidth: 170 }} size="small">
          <InputLabel id="demo-select-small">Select Passcode</InputLabel>
          <Select
            labelId="demo-select-small"
            id="demo-select-small"
            value={passcodeName}
            label="Select Passcode"
            onChange={handlePasscodeChange}>
            <MenuItem value="">
              <em>None</em>
            </MenuItem>
            {passcodeArr.map((element) => (
              <MenuItem value={element.passcode}>{element.passcode}</MenuItem>
            ))}
          </Select>
        </FormControl>

        {/* For Passcode Select */}
        <FormControl sx={{ m: 1, minWidth: 140 }} size="small">
          <InputLabel id="demo-select-small">Select User</InputLabel>
          <Select
            labelId="demo-select-small"
            id="demo-select-small"
            value={userid}
            label="Select User"
            onChange={handleUserChange}>
            <MenuItem value="">
              <em>None</em>
            </MenuItem>
            {user_data.map((element) => (
              <MenuItem value={element.userid}>{element.username}</MenuItem>
            ))}
          </Select>
        </FormControl>
        {nsdcMark.map((element) => (
          <div>
            <Button variant="outlined" style={{ marginLeft: 56, marginTop: 8 }}>
              Total Mark : {element.totalmark}
            </Button>

            {element.evaluate === "complete" ? (
              <div style={{ color: "green", marginLeft: 79 }}>
                <h3>Evaluate</h3>
              </div>
            ) : (
              <div style={{ color: "red" }}>Not Evaluated</div>
            )}

            {/* <div>
              Appeared on : <h2>{element.endtime}</h2>
            </div> */}
          </div>
        ))}
      </div>

      <div>
        <Button
          style={{ marginLeft: 12 }}
          variant="contained"
          onClick={handleNsdcUpdate}
        >
          Update
        </Button>
        <Button variant="contained" onClick={handleNsdcDelete}>
          Delete
        </Button>
      </div>
      <Box sx={{ flexGrow: 1 }}>
        <Grid container spacing={3}>
          {nsdcData.map((eachsegment, index) => (
            <Grid item xs={12} sm={isSmallScreen ? 12 : 6} md={4} key={index}>
              <Card sx={{ maxWidth: 345 }}>
                <CardHeader
                  avatar={
                    <Avatar sx={{ bgcolor: green[500] }}>
                      <AodIcon />
                    </Avatar>
                  }
                  action={
                    <>
                      <IconButton
                        id={index + 1.1}
                        // onClick={(e) => handleVertMenuClick(e, eachsegment, index)}
                        aria-controls={openVertMenu ? { index } : undefined}
                        aria-expanded={openVertMenu ? "true" : undefined}
                        aria-haspopup="true"
                      >
                        <MoreVertIcon />
                      </IconButton>
                    </>
                  }
                  title={
                    <div>
                      <div
                        style={{ cursor: "pointer" }}
                        // contentOnClick(eachsegment)
                      >
                        {index + 1} . {eachsegment.question}
                      </div>
                      <div style={{ cursor: "pointer" }}>
                        {eachsegment.inputans}
                      </div>
                      <div>
                        Mark :
                        <TextField
                          type="number"
                          inputProps={{ min: 0, max: 10 }}
                        />
                      </div>
                    </div>
                  }
                  // subheader={
                  //   <div style={{ cursor: "pointer" }} onClick={() => contentOnClick(eachsegment)}>
                  //     {eachsegment.id ? eachsegment.id : ""}
                  //   </div>
                  // }
                />
                {/* <CardMedia component="img" height="194" image={require("../../media/images/content.webp")} alt="content" />
                  <CardContent></CardContent> */}
              </Card>
            </Grid>
          ))}
          <Menu
            id={selectedIndex}
            anchorEl={anchorEl}
            open={openVertMenu}
            onClose={handleVertMenuClose}
            MenuListProps={{
              "aria-labelledby": "vert-button",
            }}
            PaperProps={{
              style: {
                maxHeight: ITEM_HEIGHT * 4.5,
                width: "20ch",
              },
            }}
          >
            <MenuItem
            // onClick={() =>
            //   update_content_button_click(selectedSegment, selectedIndex)
            // }
            >
              Edit
            </MenuItem>
            <MenuItem
            // onClick={() =>
            //   delete_content_button_click(selectedSegment, selectedIndex)
            // }
            >
              Delete
            </MenuItem>
          </Menu>
        </Grid>
      </Box>
    </div>
  );
};

export default Nsdc;

const styles = {
  select: {
    marginTop: 100,
    display: "flex",
  },
};
